const messages: Record<string, string> = {
  'site.title':           'Metha · docs',
  'site.tagline':         'Funding biomedical research on-chain.',
  'nav.search':           'Search docs…',
  'search.empty':         'No results.',
  'search.unavailable':   'Search index not built. Run `npm run build` and `npm run preview`.',
  'nav.dapp':             'Open the dapp',
  'toc.onThisPage':       'On this page',
  'nav.home':             'Home',
  'sidebar.toggle':       'Toggle navigation',
  'theme.toggle':         'Toggle theme',
  'lang.switch':          'Language',
  'home.cta.lab':         'I am a lab',
  'home.cta.auditor':     'I am an auditor',
  'home.cta.learn':       'I want to understand',
  'home.section.start':   'Quickstart',
  'home.section.status':  'Live status',
  'home.section.recent':  'Recent additions',
  'page.lastUpdated':     'Last updated',
  'page.editOnGithub':    'Edit this page on GitHub',
  'page.onThisPage':      'On this page',
  '404.title':            'Page not found',
  '404.body':             'The page you requested does not exist.',
  '404.back':             'Back to home',

  // footer
  'community':            'Community',
  'code':                 'Code & papers',
  'onchain':              'On-chain (Sepolia)',
  'disclaimer':           'Experimental software, no warranty. METH is designed as a settlement / governance instrument, not an investment security or a redemption claim on Metha assets. Nothing on this site is legal, tax, financial, or investment advice. See the risk register for known regulatory and technical exposures.',

  // ── manifest sections ──
  'manifest.section.overview':     'Overview',
  'manifest.section.how-it-works': 'How it works',
  'manifest.section.architecture': 'Architecture',
  'manifest.section.concepts':     'Core concepts',
  'manifest.section.guides':       'User guides',
  'manifest.section.security':     'Security',
  'manifest.section.risks':        'Risks',
  'manifest.section.future':       'Future developments',
  'manifest.section.literature':   'Literature',
  'manifest.section.glossary':     'Glossary',
  'manifest.section.faq':          'FAQ',
  'manifest.section.changelog':    'Changelog',

  // ── manifest leaves ──
  'manifest.leaf.overview':                    'What is Metha',
  'manifest.leaf.why-dvbc':                    'Why DVBC',
  'manifest.leaf.status':                      'Status & roadmap',
  'manifest.leaf.how-it-works/value-loop':     'The value loop',
  'manifest.leaf.how-it-works/auctions':       'Periodic auctions',
  'manifest.leaf.how-it-works/requests':       'Funding requests',
  'manifest.leaf.how-it-works/consensus':      'Auditor consensus',
  'manifest.leaf.how-it-works/governance':     'Governance',
  'manifest.leaf.architecture':                'System diagram',
  'manifest.leaf.architecture/contracts':      'Six contracts',
  'manifest.leaf.architecture/data-flow':      'Data flow',
  'manifest.leaf.architecture/evolution':      'Slot registry & evolution',
  'manifest.leaf.concepts/dvbc':               'DVBC',
  'manifest.leaf.concepts/three-conditions':   'Three conditions',
  'manifest.leaf.concepts/mechanisms-abc':     'Mechanisms A / B / C',
  'manifest.leaf.concepts/typed-deliverables': 'Typed deliverables',
  'manifest.leaf.concepts/barda-option':       'BARDA option-period',
  'manifest.leaf.concepts/dsmb-veto':          'DSMB veto',
  'manifest.leaf.concepts/slashing':           'Slashing tiers',
  'manifest.leaf.guides/lab':                  'For labs',
  'manifest.leaf.guides/auditor':              'For auditor firms',
  'manifest.leaf.guides/holder':               'For token holders',
  'manifest.leaf.guides/dsmb':                 'For DSMB members',
  'manifest.leaf.guides/program-officer':      'For Program Officers',
  'manifest.leaf.guides/developer':            'For developers',
  'manifest.leaf.guides/developer/mdx-components': 'MDX components reference',
  'manifest.leaf.security/slither':            'Slither report summary',
  'manifest.leaf.security/audits':             'Audit sequence',
  'manifest.leaf.security/reporting':          'Report a vulnerability',
  'manifest.leaf.risks':                       'Risk register',
  'manifest.leaf.future/roadmap':              'Roadmap',
  'manifest.leaf.future/research':             'Open research questions',
  'manifest.leaf.literature':                  'Papers & references',
  'manifest.leaf.glossary':                    'Glossary',
  'manifest.leaf.faq':                         'FAQ',
  'manifest.leaf.changelog':                   'Changelog',
};

export default messages;
